import {uniqBy} from "@pg-mono/nodash";
import {Currency} from "@pg-rp/common-types";

import {useGetOfferDetailApplicationQuery} from "../../../offer/api/get_offer_detail";
import {useGetPropertyDetailApplicationQuery} from "../../../property/api/get_property_detail";
import {IPreferencesDefaultValues} from "../../types/IPreferencesDefaultValues";
import {getPreferencesMaxValue} from "../../utils/preferences/get_preferences_max_value";
import {useHomeMatchPreferencesStorage} from "./use_home_match_preferences_storage";

interface IParams {
    creditPlan: boolean;
    property?: number | null;
    offer?: number | null;
}

export const PREFERENCES_BASE_VALUES = {
    budget: 0,
    creditPlan: false,
    rooms: {lower: "", upper: ""},
    regionSelector: [],
    regions: [],
    // Marketing consents only for variant 1 (FULL_OFFER) of AB test
    marketing_email: undefined,
    marketing_sms: undefined
};

export const usePreferencesValues = (
    params: IParams
): {
    defaultValues: IPreferencesDefaultValues;
    isLoading: boolean;
    currency: Currency;
    maxBudget: number;
} => {
    const skipProperty = !params.property;
    const skipOffer = !params.offer;

    const {data: propertyData, isLoading: isLoadingProperty} = useGetPropertyDetailApplicationQuery(params.property || 0, {skip: skipProperty});
    const {data: offerData, isLoading: isLoadingOffer} = useGetOfferDetailApplicationQuery(params.offer || 0, {skip: skipOffer});

    const {getPreferences} = useHomeMatchPreferencesStorage();
    const preferences = getPreferences();
    const maxBudget = getPreferencesMaxValue(preferences?.budget);

    return {
        defaultValues: {
            ...PREFERENCES_BASE_VALUES,
            creditPlan: params.creditPlan,
            rooms: {
                lower: preferences?.rooms?.lower && Number(preferences.rooms.lower) >= 6 ? 5 : preferences?.rooms?.lower || "",
                upper: preferences?.rooms?.upper && Number(preferences.rooms.upper) >= 6 ? 5 : preferences?.rooms?.upper || ""
            },
            budget: preferences?.budget || maxBudget,
            regions: uniqBy([...(preferences?.regions || []), ...(preferences?.searchRegions || [])], (reg) => reg.value),
            regionSelector: uniqBy([...(preferences?.regions || []), ...(preferences?.searchRegions || [])], (reg) => reg.value)
        },
        isLoading: isLoadingProperty || isLoadingOffer,
        currency: propertyData?.currency || offerData?.currency || Currency.PLN,
        maxBudget
    };
};
